import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useT } from "../lib/i18n";

export default function PaymentCancel() {
  const { lang } = useT();
  const enMs = (en, ms) => (lang === "en" ? en : ms);
  return (
    <div className="min-h-screen bg-[#FBFBFD] flex items-center justify-center px-4">
      <div className="bg-white rounded-[1.5rem] p-8 max-w-md w-full shadow-[0_12px_48px_rgba(0,0,0,0.06)] border border-[#E8E8ED] text-center">
        <XCircle className="w-10 h-10 text-gray-400 mx-auto mb-4" />
        <h1 className="text-xl font-semibold text-[#0A2540]" data-testid="payment-cancelled">
          {enMs("Payment cancelled", "Pembayaran dibatalkan")}
        </h1>
        <p className="text-sm text-gray-500 mt-2">
          {enMs("No worries — you have not been charged.", "Jangan risau — anda tidak dicaj.")}
        </p>
        <Link to="/paywall" data-testid="back-to-paywall-cancel" className="mt-6 inline-block chip w-full py-3 rounded-full bg-[#0A2540] hover:bg-[#0A2540]/90 text-white font-medium">
          {enMs("Back to Paywall", "Kembali ke Paywall")}
        </Link>
      </div>
    </div>
  );
}
